import { IAuthor } from "@models/author.interface";
import { config } from "config";

export function generateAuthorJsonLd(author: IAuthor) {
  return {
    "@context": "https://schema.org",
    "@type": "ProfilePage",
    headline: author.metaTitle,
    description: author.metaDescription,
    url: `${config.HOST}/blog/authors/${author.slug}`,
    isPartOf: {
      "@type": "WebSite",
      name: "Agilie",
      url: config.HOST,
    },
    mainEntity: {
      "@type": "Person",
      name: author.name,
      jobTitle: author.position,
      worksFor: {
        "@type": "Organization",
        name: "Agilie",
        url: config.HOST,
      },
      image: author.avatarFilename,
      birthPlace: "Ukraine",
      sameAs: [author.profileLink],
    },
  };
}
